/**
 * Logo Configuration File
 * 
 * This file centralizes all logo paths used throughout the application.
 * When logos need to be updated, only this file needs to be modified.
 */

// Brand Logos
export const LOGOS = {
  // Main application logos
  DRIVE360: {
    DEFAULT: '/logo/DRIVE360Logo.png',
    ALTERNATE: '/logo/DRIVE 360 Logo.png',
    ASSET: require('../assets/drive360-logo.png'),
  },
  EFRAME: {
    DEFAULT: '/logo/EframeInfomedia.png',
    ALTERNATE: '/logo/Eframe Infomedia.png',
    ASSET: require('../assets/eframe-logo.svg'),
  },
  HINDALCO: {
    DEFAULT: require('../assets/hindalco-logo.png'),
  },
  
  // React default logos (if used)
  REACT: {
    LOGO192: '/logo/logo192.png',
    LOGO512: '/logo/logo512.png',
  },
};

// Icon paths for navigation and UI elements
export const ICONS = {
  // Navigation icons
  NAVIGATION: {
    HOME: '/icon/home.png',
    SETTINGS: '/icon/SETTINGS.png',
    REPORT: '/icon/REPORT.png',
    LOGOUT: '/icon/logout (1).png',
    LOGOUT_ALT: '/icon/logout.png',
  },
  
  // Vehicle icons
  VEHICLES: {
    FORKLIFT: '/icon/forklift.png',
    MTV_WHITE: '/icon/MTV icon white.png',
    MTV_BLACK: '/icon/MTV icon black.png',
    EXCAVATOR: '/icon/excaavattor.png',
    BULLDOZER: '/icon/bulldozer.png',
    DUMPER: '/icon/dumper.png',
    MANLIFT: '/icon/manlift.png',
    TRUCK: '/icon/truck.png',
    TWO_WHEELER: '/icon/two wheeler.png',
    FOUR_WHEELER: '/icon/four wheeler.png',
  },
};

// Background images
export const BACKGROUNDS = {
  LOGIN: require('../assets/background.jpg'),
  SIDEBAR: require('../assets/sidebarbg.jpg'),
};

// Default user images
export const USER_IMAGES = {
  DEFAULT_USER: require('../assets/default-user.png'),
};

// Export a function to get image path with fallback
export const getImagePath = (primaryPath, fallbackPath = null) => {
  try {
    // For imported assets, this should work
    if (typeof primaryPath === 'string') {
      return primaryPath;
    }
    return primaryPath;
  } catch (error) {
    console.warn(`Failed to load image: ${primaryPath}`, error);
    return fallbackPath || USER_IMAGES.DEFAULT_USER;
  }
};

export default {
  LOGOS,
  ICONS,
  BACKGROUNDS,
  USER_IMAGES,
  getImagePath,
}; 